import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'Components/UI/_Legacy'

function ReadMoreButton({ href = '#' }) {
  return (
    <Button as="a" big href={href} outline style={{ textDecoration: 'none' }}>
      Read more
    </Button>
  )
}

ReadMoreButton.propTypes = {
  href: PropTypes.string,
}

export default ReadMoreButton
